import { Box, Paper } from "@mui/material";
import React from "react";

export default function TermosFamily() {
  return (
    <div
      className="terms-wrapper p-20"
      style={{ fontFamily: "Heebo , sans-serif" }}
    >
      <h2 style={{ margin: 20 }}>Perto Family - Terms of Service ("Terms")</h2>

      <Box style={{ margin: 20 }} sx={{ flexGrow: 1 }}>
        <Paper sx={{ p: 2 }}>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            Last updated: May 12, 2020
            <br />
            Please read these Terms of Service ("Terms", "Terms of Service")
            carefully before using the Perto Family mobile application (the
            "Service") operated by Crescer Idiomas Eireli - ME ("us", "we", or
            "our"). Your access to and use of the Service is conditioned on your
            acceptance of and compliance with these Terms. These Terms apply to
            all visitors, users and others who access or use the Service.
            <b>
              By accessing or using the Service you agree to be bound by these
              Terms. If you disagree with any part of the terms then you may not
              access the Service.
            </b>
          </p>
          <br />

          <h4 style={{ marginTop: 10, marginBottom: 10 }}>Privacy Policy</h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            Your use of the Service is subject to Perto Family's Privacy Policy.
            Please review our Privacy Policy, which also governs the Service and
            informs users of our data collection practices.
            <br />
            <br />
            Perto Family's Privacy Policy can be found here:{" "}
            <a
              target="_blank"
              href="https://painel.pertoeducacao.com.br/pp-perto-family"
            >
              https://pertobilingueadm.com.br/painel/pp-perto-family
            </a>
          </p>

          <br />

          <h4 style={{ marginTop: 10, marginBottom: 10 }}>Content</h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            Perto’s content is made available by deals with producers and
            distributors, always respecting copyright and intellectual property.
            The content available is licensed only for domestic purposes and can
            be streamed. Perto reserves the right to modify the content
            available at anytime
          </p>
          <br />

          <h4 style={{ marginTop: 10, marginBottom: 10 }}>Accounts</h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            When you create an account with us, you must provide us information
            that is accurate, complete, and current at all times. Failure to do
            so constitutes a breach of the Terms, which may result in immediate
            termination of your account on our Service. You are responsible for
            safeguarding the password that you use to access the Service and for
            any activities or actions under your password, whether your password
            is with our Service or a third-party service. You agree not to
            disclose your password to any third party. You must notify us
            immediately upon becoming aware of any breach of security or
            unauthorized use of your account. You may not use as a username the
            name of another person or entity or that is not lawfully available
            for use, a name or trademark that is subject to any rights of
            another person or entity other than you without appropriate
            authorization, or a name that is otherwise offensive, vulgar or
            obscene.
          </p>
          <br />
          <h4 style={{ marginTop: 10, marginBottom: 10 }}>
            Intellectual Property
          </h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            The Service and its original content, features and functionality are
            and will remain the exclusive property of Crescer Idiomas Eireli -
            ME and its licensors. The Service is protected by copyright,
            trademark, and other laws of both the Brazil and foreign countries.
            Our trademarks and trade dress may not be used in connection with
            any product or service without the prior written consent of Crescer
            Idiomas Eireli - ME.
          </p>
          <br />

          <h4 style={{ marginTop: 10, marginBottom: 10 }}>
            Links To Other Web Sites Our Service may contain links to t
          </h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            Our Service may contain links to third-party web sites or services
            that are not owned or controlled by Crescer Idiomas Eireli - ME.
            Crescer Idiomas Eireli - ME has no control over, and assumes no
            responsibility for, the content, privacy policies, or practices of
            any third party web sites or services. You further acknowledge and
            agree that Crescer Idiomas Eireli - ME shall not be responsible or
            liable, directly or indirectly, for any damage or loss caused or
            alleged to be caused by or in connection with use of or reliance on
            any such content, goods or services available on or through any such
            web sites or services. We highly advise you to read the terms and
            conditions and privacy policies of any third-party web sites or
            services that you visit.
          </p>
          <br />

          <h4 style={{ marginTop: 10, marginBottom: 10 }}>Termination</h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            We may terminate or suspend your account immediately, without prior
            notice or liability, for any reason whatsoever, including without
            limitation if you breach the Terms. Upon termination, your right to
            use the Service will immediately cease. If you wish to terminate
            your account, you may simply discontinue using the Service.
          </p>
          <br />

          <h4 style={{ marginTop: 10, marginBottom: 10 }}>
            Limitation Of Liability
          </h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            In no event shall Crescer Idiomas Eireli - ME, nor its directors,
            employees, partners, agents, suppliers, or affiliates, be liable for
            any indirect, incidental, special, consequential or punitive
            damages, including without limitation, loss of profits, data, use,
            goodwill, or other intangible losses, resulting from (i) your access
            to or use of or inability to access or use the Service; (ii) any
            conduct or content of any third party on the Service; (iii) any
            content obtained from the Service; and (iv) unauthorized access, use
            or alteration of your transmissions or content, whether based on
            warranty, contract, tort (including negligence) or any other legal
            theory, whether or not we have been informed of the possibility of
            such damage, and even if a remedy set forth herein is found to have
            failed of its essential purpose.
          </p>
          <br />

          <h4 style={{ marginTop: 10, marginBottom: 10 }}>Governing Law</h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            These Terms shall be governed and construed in accordance with the
            laws of Brazil, without regard to its conflict of law provisions.
            Our failure to enforce any right or provision of these Terms will
            not be considered a waiver of those rights. If any provision of
            these Terms is held to be invalid or unenforceable by a court, the
            remaining provisions of these Terms will remain in effect. These
            Terms constitute the entire agreement between us regarding our
            Service, and supersede and replace any prior agreements we might
            have between us regarding the Service.
          </p>
          <br />

          <h4 style={{ marginTop: 10, marginBottom: 10 }}>Disclaimer</h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            Your use of the Service is at your sole risk. The Service is
            provided on an "AS IS" and "AS AVAILABLE" basis. The Service is
            provided without warranties of any kind, whether express or implied,
            including, but not limited to, implied warranties of
            merchantability, fitness for a particular purpose, non-infringement
            or course of performance. Crescer Idiomas Eireli - ME its
            subsidiaries, affiliates, and its licensors do not warrant that a)
            the Service will function uninterrupted, secure or available at any
            particular time or location; b) any errors or defects will be
            corrected; c) the Service is free of viruses or other harmful
            components; or d) the results of using the Service will meet your
            requirements.
          </p>
          <br />

          <h4 style={{ marginTop: 10, marginBottom: 10 }}>Changes</h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            We reserve the right, at our sole discretion, to modify or replace
            these Terms at any time. So please come back and review them. If a
            revision is material we will notify you prior to any new terms
            taking effect. What constitutes a material change will be determined
            at our sole discretion. By continuing to access or use our Service
            after those revisions become effective, you agree to be bound by the
            revised terms. If you do not agree to the new terms, please stop
            using the Service.
          </p>
          <br />

          <h4 style={{ marginTop: 10, marginBottom: 10 }}>Contact Us</h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            If you have any questions about these Terms, please contact us.
          </p>
        </Paper>
      </Box>
    </div>
  );
}
